var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HCaptcha',{ref:"hCaptchaRef",on:{"onChallengeExpired":_vm.onClose,"onClosed":_vm.onClose,"onError":_vm.onError,"onExpired":_vm.onClose,"onOpened":_vm.onOpen,"onVerify":_vm.onVerify}})}
var staticRenderFns = []

export { render, staticRenderFns }